import { type InputHTMLAttributes, forwardRef, useId } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helpText?: string;
  isInvalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ label, error, helpText, isInvalid, className, id, ...props }, ref) => {
  const generatedId = useId();
  const inputId = id || generatedId;
  const inputClassName = `form-control ${isInvalid || error ? 'is-invalid' : ''} ${className || ''}`;

  return (
    <div className="mb-3">
      {label && (
        <label htmlFor={inputId} className="form-label">
          {label}
        </label>
      )}
      <input ref={ref} id={inputId} className={inputClassName} {...props} />
      {helpText && !error && <div className="form-text">{helpText}</div>}
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
});

Input.displayName = 'Input';
